module.exports = __webpack_public_path__ + "img/icon-user.ae803d76.svg";